import * as React from 'react';
import * as Configuration from '../configuration';
import * as classNames from "classnames";
import { withTheme } from '../common/withTheme';

class SidebarLogo extends React.PureComponent<any, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return this.props.display ?
            <div className={classNames(this.props.theme, "sidebarlogo px-1 text-center mt-auto d-xl-block d-none")}>
                <img className="w-100" src={Configuration.custom.footerLogo} />
            </div>
            : <div />;
    }
}
export default withTheme(SidebarLogo);
